
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/item",
      function () {
        return require("private-next-pages/item/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/item"])
      });
    }
  